export default function CustomerImport() {
    return <div>Customer Import Screen</div>;
}